var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteExpertFeedbacksArrowrightMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 34,
    viewBox: "0 0 10 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29259 33.0563C1.10512 32.6656 0.999806 32.1358 0.999806 31.5834C0.999806 31.0309 1.10512 30.5011 1.29259 30.1105L7.58559 17L1.29259 3.88962C1.19708 3.69744 1.1209 3.46756 1.06849 3.21338C1.01608 2.95921 0.988496 2.68583 0.987342 2.40921C0.986189 2.13258 1.01149 1.85826 1.06177 1.60222C1.11205 1.34619 1.18631 1.11358 1.2802 0.917969C1.37409 0.722359 1.48574 0.567661 1.60864 0.46291C1.73154 0.358158 1.86321 0.305447 1.99599 0.30785C2.12877 0.310253 2.25999 0.367725 2.382 0.476913C2.504 0.586098 2.61435 0.744808 2.70659 0.943787L9.70659 15.5271C9.89406 15.9178 9.99938 16.4476 9.99938 17C9.99938 17.5525 9.89406 18.0823 9.70659 18.473L2.70659 33.0563C2.51907 33.4469 2.26476 33.6663 1.99959 33.6663C1.73443 33.6663 1.48012 33.4469 1.29259 33.0563Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpertFeedbacksArrowrightMobile);
export default __webpack_public_path__ + "static/media/note-expert-feedbacks-arrowright-mobile.6bded98bc1346c6c1d75ecb41937c60e.svg";
export { ForwardRef as ReactComponent };